<button class="btn btn-sm btn-secondary" (click)="sendMessageClick()">
  <span [hidden]="sendingMessage">Send Test Message</span>
  <span [hidden]="!sendingMessage">
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" /> Sending...
  </span>
</button>
@if (errorMessage) {
  <p class="text-danger small my-2">
    {{ errorMessage }}
  </p>
}
